export class CSVHelpers {
    public static jsonToCsv(arrayOfObjects: any[]): string {
        if (!Array.isArray(arrayOfObjects) || arrayOfObjects.length === 0) {
            return '';
        }

        // Get headers from the first object
        const headers = Object.keys(arrayOfObjects[0]);

        // Helper function to escape CSV values
        const escapeCsvValue = (value: any): string => {
            if (value === null || value === undefined) {
                return '';
            }
            // Convert arrays to JSON string
            if (Array.isArray(value)) {
                value = JSON.stringify(value);
            }
            // Convert other values to string and handle quotes
            let strValue = String(value);
            if (strValue.includes(',') || strValue.includes('"') || strValue.includes('\n')) {
                strValue = `"${strValue.replace(/"/g, '""')}"`;
            }
            return strValue;
        };

        // Create CSV header row
        const headerRow = headers.map(escapeCsvValue).join(',');

        // Create CSV data rows
        const dataRows = arrayOfObjects.map(obj =>
            headers.map(header => escapeCsvValue(obj[header])).join(',')
        );

        return headerRow + '\n' + dataRows.join('\n');
    }

    public static csvToJson(csvString: string): any[] {
        if (!csvString || typeof csvString !== 'string') {
            return [];
        }

        // Parse CSV string into rows and fields
        const { rows } = CSVHelpers.parseCsvRows(csvString);
        if (rows.length === 0) {
            return [];
        }

        // Extract headers from the first row
        const headers = rows[0];

        // Parse data rows into objects
        return rows.slice(1).map(row => {
            const obj: { [key: string]: any } = {};

            headers.forEach((header, index) => {
                let value = row[index] || '' as any;

                // Try to parse JSON arrays
                try {
                    if (value.startsWith('[') && value.endsWith(']')) {
                        value = JSON.parse(value);
                    }
                    // Try to parse numbers
                    else if (!isNaN(Number(value)) && value.trim() !== '') {
                        value = Number(value);
                    }
                } catch (e) {
                    // If parsing fails, keep as string
                }

                obj[header] = value;
            });

            return obj;
        });
    }

    // Helper function to parse CSV string into rows, handling quoted values with newlines
    private static parseCsvRows(csvString: string): { rows: string[][] } {
        const rows: string[][] = [];
        let currentRow: string[] = [];
        let currentField = '';
        let inQuotes = false;
        let i = 0;

        while (i < csvString.length) {
            const char = csvString[i];

            if (char === '"') {
                if (inQuotes && csvString[i + 1] === '"') {
                    // Escaped quote
                    currentField += '"';
                    i += 2;
                } else {
                    // Toggle quoted state
                    inQuotes = !inQuotes;
                    i++;
                }
            } else if (char === ',' && !inQuotes) {
                // End of field
                currentRow.push(currentField);
                currentField = '';
                i++;
            } else if (char === '\n' && !inQuotes) {
                // End of row
                currentRow.push(currentField);
                if (currentRow.some(field => field.trim() !== '')) {
                    rows.push(currentRow);
                }
                currentRow = [];
                currentField = '';
                i++;
            } else {
                // Add character to current field
                currentField += char;
                i++;
            }
        }

        // Handle the last field and row
        if (currentField !== '' || currentRow.length > 0) {
            currentRow.push(currentField);
            if (currentRow.some(field => field.trim() !== '')) {
                rows.push(currentRow);
            }
        }

        return { rows };
    }
}